<template>
    <div class="container-xl ">
      <div class="hidden">
          <vs-sidebar 
            right
            absolute
            square
            notShadow
            open
            id="sidebar"
            notLineActive
            v-model="active" class="pb-5">
              <vs-sidebar-item class="text-dark my-2 border-bottom d-flex">
                
                <!-- <vs-switch dark v-model="active5" style="width:35px;">
                  <template #circle>
                      <font-awesome-icon v-if="!active5" icon="fa-solid fa-moon"></font-awesome-icon>
                      <font-awesome-icon v-else  icon="fa-solid fa-sun"></font-awesome-icon>
                  </template>
                </vs-switch> -->
                <strong style="font-size:.7rem;">Componentes</strong>
              </vs-sidebar-item>
              <vs-sidebar-item id="botones">Botones</vs-sidebar-item>
              <vs-sidebar-item id="modales">Modales</vs-sidebar-item>
              <vs-sidebar-item id="notificaciones">Notificaciones</vs-sidebar-item>
              <vs-sidebar-item id="tipografia">Tipografía</vs-sidebar-item>

              <vs-sidebar-item id="input">Input</vs-sidebar-item>
              <vs-sidebar-item id="input">Textarea</vs-sidebar-item>
              <vs-sidebar-item id="input">Moneda</vs-sidebar-item>


              <vs-sidebar-item id="radio-check">Check</vs-sidebar-item>
              <vs-sidebar-item id="radio-check">Switch</vs-sidebar-item>
              <vs-sidebar-item id="radio-check">Radio</vs-sidebar-item>

              <vs-sidebar-item id="selects">Select</vs-sidebar-item>
              <vs-sidebar-item id="colors">Background</vs-sidebar-item>
              <vs-sidebar-item id="tablas">Tablas</vs-sidebar-item>
              <vs-sidebar-item id="collapses">Collapses</vs-sidebar-item>
              <vs-sidebar-item id="card">Contenedores</vs-sidebar-item>
              <vs-sidebar-item id="treeView">TreeView</vs-sidebar-item>

              <vs-sidebar-item id="tabs">Tabs</vs-sidebar-item>
              <vs-sidebar-item id="cards">Cards</vs-sidebar-item>
              <vs-sidebar-item id="progress" class="d-none">Progress bar</vs-sidebar-item>
              <vs-sidebar-item id="loader">Loader</vs-sidebar-item>
              <vs-sidebar-item id="icons">Icons</vs-sidebar-item>
          </vs-sidebar>
      </div>
      <div class="contenedor-plantilla">
        <px-buttons v-if="active=='botones'"></px-buttons>
        <PxModal v-if="active=='modales'"></PxModal>
        <px-notification v-if="active=='notificaciones'"></px-notification>
        <px-typography v-if="active=='tipografia'"></px-typography>
        <px-inputs v-if="active=='input'"></px-inputs>
        <px-Radiocheck v-if="active=='radio-check'"></px-Radiocheck>
        <px-selects v-if="active=='selects'"></px-selects>
        <px-colors v-if="active=='colors'"></px-colors>
        <px-tables v-if="active=='tablas'"></px-tables>
        <px-collapse v-if="active=='collapses'"></px-collapse>
        <px-tabs v-if="active=='tabs'"></px-tabs>
        <px-progress-bars v-if="active== 'progress'"></px-progress-bars>
        <px-card-contenedor v-if="active=='card'"></px-card-contenedor>
        <px-tree-view v-if="active=='treeView'"></px-tree-view>
        <px-cards v-if="active=='cards'"></px-cards>
        <px-load v-if="active=='loader'"></px-load>
        <px-icons v-if="active=='icons'"></px-icons>
      </div>
    </div>
</template>
<script>
    import PxButtons from '@/components/ComponentesPlantilla/PxButtons.vue';
    import PxLoad from '@/components/ComponentesPlantilla/PxLoad.vue';
    import PxModal from '@/components/ComponentesPlantilla/PxModalComponent.vue';
    import PxNotification from '@/components/ComponentesPlantilla/PxNotification.vue';
    import PxTypography from '@/components/ComponentesPlantilla/PxTypography.vue'; 
    import PxColors from '@/components/ComponentesPlantilla/PxColors.vue'
    import PxSelects from '@/components/ComponentesPlantilla/PxSelects.vue'
    import PxTables from '@/components/ComponentesPlantilla/PxTablaComponent.vue'
    import PxInputs from '@/components/ComponentesPlantilla/PxInputs.vue';
    import PxRadiocheck from '@/components/ComponentesPlantilla/PxRadiocheck.vue';
    import PxCollapse from '@/components/ComponentesPlantilla/PxCollapse.vue';
    import PxTabs from '@/components/ComponentesPlantilla/PxTabs.vue';
    import PxProgressBars from '@/components/ComponentesPlantilla/PxProgressBars.vue';
    import PxCardContenedor from '@/components/ComponentesPlantilla/PxEjemploFormulario.vue';
    import PxTreeView from '@/components/ComponentesPlantilla/PxTreeView.vue';
    import PxCards from '@/components/ComponentesPlantilla/PxCards.vue';
    import PxPruebas from '@/components/ComponentesPlantilla/PxPruebas.vue'
    import PxIcons from '@/components/ComponentesPlantilla/PxIconComponent.vue'

    
    export default {
      name: 'ComponentePlantilla',
      components: {
        PxButtons,
        PxModal,
        PxNotification,
        PxTypography,
        PxColors,
        PxSelects,
        PxTables,
        PxInputs,
        PxRadiocheck,
        PxCollapse,
        PxCardContenedor,
        PxTreeView,
        PxTabs,
        PxProgressBars,
        PxCards,
        PxLoad,
        PxPruebas,
        PxIcons
      },
      data: function(){
        return{
          verModal: false,
          confirmar: false,
          activeSidebar: true,
          active: 'botones',
          active5:false
        }
      },
      methods:{
        top(){
          window.scrollTo(0, 0);
        }
      }
    }
    </script>
<style scoped>
#sidebar {
  position: fixed !important;
  z-index: 500 !important;
  top: 2.938rem;
  /* background-color: #f8f9fa30; */
}
.vs-sidebar-content { 
  width: 8rem;
}

.vs-sidebar__item {
  display: flex;
  justify-content: flex-end;
  font-weight: normal;
  padding: 0.188rem 1rem;
}
.vs-sidebar__item__text { font-size: .7rem; }
.vs-sidebar__item.active {
  color: #de879c;
  font-weight: 600;
}

.contenedor-plantilla{ margin: 0 1rem; }

@media (max-width: 800px) {
  #sidebar { display: none; }
}
@media (max-width:900) {
  .contenedor-plantilla{ margin: 0; }
}

</style>